import React, {useEffect} from "react";

/**
 *
 * @param {React.MutableRefObject<Object>} ref
 * @param {Function} callBack
 */
export function useOutseClickHook(ref, callBack) {

	const ignoreElementNames = [
		'do_toggle_services'
	]
	useEffect(() => {

		function handleClickOutside(event) {
			if (ignoreElementNames.includes(event.target?.name)) {
				return;
			}

			if (ref.current && !ref.current.contains(event.target)) {
				if (typeof callBack === 'function') {
					callBack();
				}
			}
		}

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [ref]);
}
